// extracted by mini-css-extract-plugin
export var ScrollList = "q_v";
export var aniSpin = "q_d";
export var inner = "q_r";
export var shadowBottom = "q_x";
export var shadowTop = "q_w";